import { type Question } from '@/types'

import { generateId } from '../utils'
import { findMatrixRowByFormIndex } from './findMatrixRowByFormIndex'
import { getMatrixRowPosition } from './getMatrixRowPosition'
import { truncateText } from './truncateText'

export const getMatrixRowQuestionInfo = (
  questions: Question[],
  rowFormIndex: string
) => {
  const cleanIndex = rowFormIndex.replace('R', '')

  const matrixRow = findMatrixRowByFormIndex(questions, Number(cleanIndex))
  const position = getMatrixRowPosition(questions, cleanIndex)

  const defaultTitle = 'Removed'
  const title = matrixRow?.text || defaultTitle
  const description = [position, title].join(' ')
  return {
    classes: matrixRow ? '' : 'removed',
    description,
    id: generateId(),
    title: truncateText(description),
  }
}
